import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"font-size":"15px","color":"#b03535","text-align":"left","font-weight":"bold","margin-left":"20px"} }
const _hoisted_2 = ["model"]
const _hoisted_3 = { class: "wrap_header" }
const _hoisted_4 = {
  key: 0,
  class: "menubar"
}
const _hoisted_5 = {
  key: 1,
  class: "menubar"
}
const _hoisted_6 = {
  key: 2,
  class: "menubar"
}
const _hoisted_7 = { class: "logouts" }
const _hoisted_8 = {
  key: 1,
  id: "fotter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString($setup.currentTime.toLocaleTimeString('en-GB')) + " " + _toDisplayString($setup.currentTime.toLocaleDateString('en-GB')), 1),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "header",
          model: $setup.homeMenu
        }, [
          _createElementVNode("div", _hoisted_3, [
            ($setup.permission == 'admin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/thongkebenhnhan" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("span", {
                            class: "p-menuitem-icon pi pi-fw pi-users",
                            "data-pc-section": "icon"
                          }, null, -1),
                          _createTextVNode("Thống kê bệnh nhân")
                        ])),
                        _: 1,
                        __: [0]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/thongkedoanhthu" }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createElementVNode("span", {
                            class: "p-menuitem-icon pi pi-fw pi-dollar",
                            "data-pc-section": "icon"
                          }, null, -1),
                          _createTextVNode("Thống kê doanh thu")
                        ])),
                        _: 1,
                        __: [1]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/thongtintructuyen" }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createElementVNode("span", {
                            class: "p-menuitem-icon pi pi-fw pi-sync",
                            "data-pc-section": "icon"
                          }, null, -1),
                          _createTextVNode("Thống kê trực tuyến")
                        ])),
                        _: 1,
                        __: [2]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/registerPage" }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createElementVNode("span", {
                            class: "p-menuitem-icon pi pi-fw pi-user-plus",
                            "data-pc-section": "icon"
                          }, null, -1),
                          _createTextVNode("Đăng ký tài khoản")
                        ])),
                        _: 1,
                        __: [3]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/userList" }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createElementVNode("span", {
                            class: "p-menuitem-icon pi pi-fw pi-users",
                            "data-pc-section": "icon"
                          }, null, -1),
                          _createTextVNode("Quản lý tài khoản")
                        ])),
                        _: 1,
                        __: [4]
                      })
                    ])
                  ])
                ]))
              : ($setup.permission == 'ketoan')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_RouterLink, { to: "/thongkedoanhthu" }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createElementVNode("span", {
                              class: "p-menuitem-icon pi pi-fw pi-dollar",
                              "data-pc-section": "icon"
                            }, null, -1),
                            _createTextVNode("Thống kê doanh thu")
                          ])),
                          _: 1,
                          __: [5]
                        })
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_RouterLink, { to: "/thongkebenhnhan" }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createElementVNode("span", {
                              class: "p-menuitem-icon pi pi-fw pi-users",
                              "data-pc-section": "icon"
                            }, null, -1),
                            _createTextVNode("Thống kê bệnh nhân")
                          ])),
                          _: 1,
                          __: [6]
                        })
                      ])
                    ])
                  ])),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                style: {"background":"#f44242","color":"#ffffff","font-size":"16px","font-family":"Oswald, sans-serif","text-transform":"uppercase"},
                label: "Đăng xuất",
                onClick: $setup.logout,
                icon: "pi pi-sign-out",
                iconPos: "right",
                class: "p-button-secondary"
              }, null, 8, ["onClick"])
            ])
          ])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[7] || (_cache[7] = [
          _createElementVNode("div", { class: "wrap_header" }, [
            _createElementVNode("p", { class: "coppyi" }, "© Copyright 2025 - Trung tâm y tế Hoà Vang ")
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}